import { message } from "antd";
import { useIntl } from "react-intl";
import { GET_VENUES } from "@ticketingplatform/api/dist/venue";
import { useVenueDeleteMutation } from "@ticketingplatform/api/dist/venue/hooks";
import { useCallback } from "react";

export const useVenueDelete = () => {
  const intl = useIntl();
  const [callDeleteVenueMutation, { data, loading }] = useVenueDeleteMutation({
    evictQueries: [GET_VENUES],
    onCompleted: () =>
      message.success(
        intl.formatMessage({
          defaultMessage: "Venue has been removed!",
        })
      ),
    onError: () =>
      message.error(
        intl.formatMessage({
          defaultMessage: "Cannot remove the venue",
        })
      ),
  });

  const deleteVenue = useCallback(
    (id: number) =>
      callDeleteVenueMutation({
        variables: { id },
      }),
    [callDeleteVenueMutation]
  );

  return {
    deleteVenue,
    loading,
    data,
  };
};
